import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=f9d0ba6e&scoped=true&"
import script from "./BookingCard.vue?vue&type=script&lang=ts&"
export * from "./BookingCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingCard.vue?vue&type=style&index=0&id=f9d0ba6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d0ba6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VIcon,VImg,VTooltip})
